import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/emailTemplate/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemEmail(payload) {
  return request(`/emailTemplate`, {
    params: toQuery(payload.params),
  });
}

export async function queryAddNewEmail(data) {
  return request.post('/emailTemplate', {
    data,
  });
}

export async function queryAddEditEmail(data) {
  return request.put('/emailTemplate', {
    data,
  });
}
